<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.nuevo}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                     [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                     [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion" [pagination]="true"
                     [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [innTemplate]="abrirModal"
                [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModal>
  <div class="container-fluid">
    <form [formGroup]="agregarForm" mat-dialog-content>
      <div class="row">
        <div class="row">
          <div *ngIf="!isCreate" class="form-group col-3">
            <app-lfsa-input [control]="this.agregarForm.get('id')" [id]="'id'" [label]="'ID'" formControlName="id"
                            type="number"></app-lfsa-input>
            <small *ngIf="this.agregarForm.get('id')?.hasError('pattern')" class="letrasDanger">*Solo
              números y punto, hasta 4 decimales. Ej: 12.3456</small>
          </div>

          <div class="form-group col-12">
            <app-lfsa-input [control]="this.agregarForm.get('nombre')" [id]="'nombre'" [label]="'Nombres'"
                            formControlName="nombre"
                            type="text"></app-lfsa-input>
          </div>

          <div class="form-group col-6">
            <label for="">Email</label>
            <input class="form-control" formControlName="email" id="'email'" type="tel" type="text">
            <small *ngIf="this.agregarForm.get('email')?.hasError('requerid')" class="letrasDanger">*Campo
              requerido</small>
            <small *ngIf="this.agregarForm.get('email')?.hasError('pattern')" class="letrasDanger">*Debe ser un email
              válido</small>
          </div>

          <div class="form-group col-6">
            <app-lfsa-input [control]="this.agregarForm.get('telefono')" [id]="'telefono'" [label]="'Telefono'"
                            formControlName="telefono" type="tel"></app-lfsa-input>
          </div>
        </div>

        <!-- (ejecutarEvento)="getCuentasContables()" -->
        <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [formularioValido]="agregarForm.invalid"
                                     [loading]="loading" [textBoton]="'Guardar'" class="row mt-3">
        </app-lfsa-botones-formulario>
      </div>
    </form>
  </div>
</ng-template>
<!-- END MODAL -->
